function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3710,
    height: 3710
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3462.5703,
    y1: 3283.7275,
    x2: 1386.9581,
    y2: 1467.5684
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M3109.824,2340.515c-268.253,631.627-982.816,985.469-1602.486,890.022 c-100.833-15.532-377.269-61.797-622.015-280.059C414.171,2530.305,313.411,1698.31,693.475,1111.982 c276.62-426.743,772.49-668.65,1243.664-656.549c101.491,2.606,490.446,18.67,832.27,300.531 c50.207,41.4,160.944,139.777,260.745,295.847C3264.504,1418.29,3284.648,1928.876,3109.824,2340.515z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000079463609458450307710000011331989293447024002_",
    gradientUnits: "userSpaceOnUse",
    x1: 7554.0195,
    y1: 5892.332,
    x2: 7791.6396,
    y2: 5892.332,
    gradientTransform: "matrix(0.6008 0.7995 0.7995 -0.6008 -8085.0972 -1024.9983)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000079463609458450307710000011331989293447024002_)"
    },
    d: "M1018.337,1618.994 c0,0,275.156,233.417,385.917-110.005c0,0,1.762-8.58-2.367-19.751c-2.085-5.641-2.015-27.011-1.832-37.957 c0.059-3.519-2.94-6.285-6.447-5.986l0,0c-2.747,0.235-5.186,1.853-6.471,4.293l-23.533,44.699 c-0.872,8.157,4.326,15.733,12.249,17.858l0,0c5.054,1.355,7.603,6.993,5.23,11.658c-97.104,190.884-344.464,46.224-347.98,49.099 C1020.629,1583.099,1006.149,1594.501,1018.337,1618.994z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000071521352474787349480000010481819247992965260_",
    gradientUnits: "userSpaceOnUse",
    x1: 2086.5742,
    y1: 1497.1666,
    x2: 3384.4697,
    y2: 1497.1666,
    gradientTransform: "matrix(-0.2121 -0.9772 -0.9772 0.2121 4548.6719 3621.4692)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000071521352474787349480000010481819247992965260_)"
    },
    d: "M1916.614,751.333 c-1.658-10.944,5.189-21.599,16.135-24.446c23.939-6.236,48.506-11.52,73.014-15.713c11.925-2.04,23.244,5.97,25.283,17.891 c0.022,0.144,0.043,0.283,0.064,0.423c1.782,11.765-6.178,22.843-17.959,24.858c-23.285,3.981-46.62,9.005-69.361,14.925 c-11.702,3.05-23.667-3.967-26.714-15.675C1916.877,752.843,1916.728,752.087,1916.614,751.333z M2105.455,724.151 c-0.128-0.846-0.208-1.712-0.237-2.59c-0.395-12.088,9.085-22.211,21.173-22.606c24.83-0.807,49.941-0.562,74.631,0.733 c12.079,0.632,21.325,10.89,20.73,23.015c-0.636,12.079-10.946,21.354-23.015,20.722c-23.469-1.229-47.323-1.461-70.922-0.689 C2116.605,743.102,2107.094,734.973,2105.455,724.151z M2295.583,739.225c-0.365-2.41-0.331-4.925,0.159-7.456 c2.312-11.871,13.803-19.629,25.676-17.323c24.336,4.723,48.773,10.569,72.627,17.372 c11.631,3.325,18.355,15.445,15.055,27.067c-3.317,11.629-15.438,18.371-27.067,15.054 c-22.653-6.462-45.851-12.01-68.965-16.498C2303.727,755.628,2296.931,748.123,2295.583,739.225z M2477.605,796.447 c-0.604-3.984-0.114-8.18,1.64-12.136c4.901-11.056,17.841-16.044,28.896-11.144c22.679,10.062,45.195,21.22,66.923,33.169 c10.583,5.834,14.45,19.142,8.633,29.745c-5.827,10.595-19.145,14.46-29.744,8.633c-20.633-11.349-42.018-21.952-63.572-31.504 C2483.284,810.057,2478.689,803.599,2477.605,796.447z M2642.293,892.821c-0.846-5.587,0.457-11.495,4.103-16.378 c7.235-9.696,20.958-11.689,30.646-4.453c19.832,14.802,39.314,30.664,57.887,47.145c9.054,8.02,9.888,21.862,1.855,30.914 c-8.026,9.045-21.865,9.875-30.919,1.85c-17.653-15.668-36.169-30.742-55.016-44.81 C2646.04,903.5,2643.126,898.318,2642.293,892.821z M2781.551,1023.216c-1.096-7.236,1.453-14.855,7.428-19.957 c9.202-7.853,23.02-6.762,30.876,2.434c16.093,18.851,31.584,38.631,46.023,58.788c7.046,9.838,4.782,23.514-5.052,30.559 c-9.825,7.043-23.51,4.782-30.554-5.048c-13.725-19.153-28.434-37.944-43.728-55.857 C2783.79,1030.91,2782.143,1027.12,2781.551,1023.216z M2953.31,1808.836c-0.454-2.998-0.29-6.133,0.59-9.239 c6.416-22.637,11.93-45.86,16.382-69.02c2.284-11.875,13.764-19.654,25.635-17.368c11.879,2.279,19.657,13.759,17.373,25.638 c-4.689,24.391-10.492,48.852-17.245,72.69c-3.298,11.639-15.408,18.397-27.043,15.098 C2960.468,1824.221,2954.556,1817.066,2953.31,1808.836z M2888.379,1181.128c-1.361-8.982,3-18.231,11.498-22.68 c10.718-5.612,23.95-1.474,29.562,9.239c11.503,21.96,22.188,44.688,31.761,67.554c4.618,11.175-0.579,23.989-11.742,28.661 c-11.155,4.67-23.986-0.589-28.662-11.746c-9.087-21.716-19.235-43.297-30.156-64.151 C2889.484,1185.789,2888.733,1183.467,2888.379,1181.128z M2984.3,1620.596c-0.217-1.429-0.301-2.9-0.225-4.4 c1.187-23.514,1.368-47.391,0.556-70.966c-0.412-12.089,9.049-22.227,21.133-22.643c12.085-0.412,22.28,9.032,22.643,21.133 c0.851,24.806,0.66,49.931-0.583,74.673c-0.61,12.08-10.898,21.382-22.974,20.772 C2994.274,1638.635,2985.827,1630.678,2984.3,1620.596z M2957.256,1358.945c-1.656-10.927,5.168-21.57,16.094-24.436 c11.7-3.071,23.67,3.924,26.749,15.622c6.285,23.953,11.622,48.5,15.846,72.959c0.032,0.15,0.055,0.307,0.079,0.46 c1.78,11.748-6.156,22.814-17.917,24.851c-11.922,2.061-23.254-5.925-25.312-17.847c-4.021-23.232-9.093-46.546-15.068-69.305 C2957.532,1360.482,2957.372,1359.71,2957.256,1358.945z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098184571185419974140000011931200710489620130_",
    gradientUnits: "userSpaceOnUse",
    x1: -662.8976,
    y1: 1309.7664,
    x2: -589.9429,
    y2: 1309.7664,
    gradientTransform: "matrix(0.1498 0.9887 -0.9887 0.1498 4316.0396 2356.4021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098184571185419974140000011931200710489620130_)"
    },
    d: "M2898.167,1952.388 c-0.646-4.263-0.047-8.762,2.004-12.927c4.989-10.13,9.841-20.534,14.445-30.922c4.891-11.058,17.83-16.06,28.885-11.164 c11.063,4.891,16.077,17.832,11.16,28.89c-4.833,10.929-9.942,21.868-15.188,32.531c-5.339,10.85-18.47,15.322-29.315,9.983 C2903.466,1965.489,2899.205,1959.239,2898.167,1952.388z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088114739783605775120000007559683624159795372_",
    gradientUnits: "userSpaceOnUse",
    x1: -284.2264,
    y1: 1867.236,
    x2: -234.1641,
    y2: 1867.236,
    gradientTransform: "matrix(0.1498 0.9887 -0.9887 0.1498 4316.0396 2356.4021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088114739783605775120000007559683624159795372_)"
    },
    d: "M2392.846,2388.777 c-1.583-10.45,4.602-20.796,14.991-24.118c10.754-3.433,21.619-7.152,32.285-11.052c11.363-4.153,23.937,1.69,28.089,13.048 c4.168,11.408-1.695,23.938-13.049,28.089c-11.231,4.103-22.672,8.021-33.995,11.639c-11.521,3.679-23.844-2.677-27.527-14.198 C2393.278,2391.055,2393.018,2389.914,2392.846,2388.777z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057858453173333956340000008480002360708976565_",
    gradientUnits: "userSpaceOnUse",
    x1: 1635.5448,
    y1: 2349.1741,
    x2: 2968.8413,
    y2: 2349.1741,
    gradientTransform: "matrix(-0.2121 -0.9772 -0.9772 0.2121 4548.6719 3621.4692)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057858453173333956340000008480002360708976565_)"
    },
    d: "M1289.479,1705.112 c-1.509-9.963-2.855-19.99-4.038-30.077c-1.404-12.013,7.191-22.893,19.203-24.302c12.012-1.409,22.944,7.24,24.306,19.199 c2.73,23.28,6.397,46.396,10.959,68.966c2.378,11.87-5.27,23.407-17.124,25.804c-11.862,2.398-23.416-5.273-25.809-17.128 C1294.152,1733.613,1291.632,1719.326,1289.479,1705.112z M1279.858,1559.549c-0.183-1.209-0.267-2.455-0.243-3.722 c0.46-24.43,1.964-49.113,4.468-73.359c1.24-12.028,12.002-20.775,24.026-19.534c12.033,1.244,20.812,12.023,19.535,24.035 c-2.377,23.029-3.8,46.475-4.245,69.691c-0.227,12.091-10.217,21.707-22.304,21.479 C1290.266,1577.932,1281.427,1569.906,1279.858,1559.549z M1327.583,1858.68c-1.547-10.209,4.325-20.395,14.423-23.928 c11.422-3.993,23.91,2.027,27.907,13.444c7.634,21.84,16.312,43.649,25.802,64.827c4.927,11.047,0.001,23.996-11.034,28.939 c-11.043,4.943-24,0.002-28.943-11.037c-9.989-22.302-19.127-45.273-27.172-68.272 C1328.107,1861.339,1327.784,1860.008,1327.583,1858.68z M1304.068,1373.327c-0.416-2.749-0.306-5.62,0.393-8.486 c5.813-23.709,12.71-47.457,20.498-70.579c3.861-11.46,16.279-17.62,27.739-13.759c11.469,3.861,17.632,16.272,13.764,27.743 c-7.393,21.955-13.944,44.504-19.462,67.022c-2.874,11.748-14.738,18.935-26.482,16.055 C1311.639,1389.147,1305.358,1381.839,1304.068,1373.327z M1408.758,2027.842c-1.269-8.373,2.411-17.09,10.055-21.865 c10.259-6.408,23.771-3.286,30.179,6.974c12.246,19.614,25.511,38.98,39.418,57.565c7.247,9.682,5.277,23.409-4.414,30.656 c-9.683,7.243-23.401,5.268-30.648-4.415c-14.645-19.563-28.609-39.952-41.507-60.605 C1410.21,2033.54,1409.193,2030.709,1408.758,2027.842z M1525.09,2175.1c-1.014-6.694,1.081-13.764,6.266-18.885 c8.611-8.494,22.477-8.402,30.972,0.209c16.293,16.51,33.471,32.527,51.053,47.604c9.194,7.86,10.258,21.681,2.376,30.878 c-7.875,9.183-21.696,10.243-30.883,2.373c-18.505-15.867-36.58-32.721-53.723-50.098 C1527.778,2183.764,1525.759,2179.515,1525.09,2175.1z M1670.758,2293.492c-0.771-5.092,0.239-10.47,3.252-15.14 c6.55-10.164,20.106-13.091,30.27-6.537c19.513,12.583,39.761,24.478,60.202,35.355c10.672,5.681,14.731,18.931,9.039,29.622 c-5.686,10.674-18.941,14.723-29.623,9.039c-21.504-11.45-42.825-23.967-63.354-37.205 C1675.048,2305.081,1671.666,2299.489,1670.758,2293.492z M1838.766,2377.293c-0.534-3.528-0.213-7.232,1.104-10.818 c4.172-11.352,16.754-17.169,28.105-12.996c21.779,8.008,44.14,15.172,66.473,21.297c11.663,3.2,18.527,15.263,15.333,26.908 c-3.198,11.667-15.25,18.529-26.913,15.329c-23.524-6.45-47.076-13.996-70.001-22.424 C1845.098,2391.729,1839.924,2384.935,1838.766,2377.293z M2021.144,2422.184c-0.3-1.983-0.327-4.043-0.054-6.131 c1.566-11.99,12.562-20.444,24.55-18.873c22.95,2.999,46.329,5.06,69.503,6.117c12.084,0.552,21.42,10.832,20.874,22.876 c-0.549,12.083-10.796,21.431-22.88,20.878c-24.394-1.115-49.01-3.282-73.169-6.444 C2030.064,2439.313,2022.569,2431.589,2021.144,2422.184z M2208.801,2425.909c-0.067-0.444-0.118-0.895-0.16-1.347 c-1.081-12.044,7.81-22.688,19.855-23.765c17.005-1.525,34.159-3.592,51.008-6.145c6.098-0.924,12.177-1.918,18.221-2.968 c11.92-2.07,23.261,5.912,25.326,17.828c2.332,12.024-5.908,23.252-17.819,25.325c-6.365,1.107-12.748,2.147-19.167,3.12 c-17.719,2.685-35.776,4.858-53.659,6.46C2220.813,2445.459,2210.521,2437.263,2208.801,2425.909z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148628956092909201080000015270708147394804917_",
    gradientUnits: "userSpaceOnUse",
    x1: -1638.3842,
    y1: 2707.8809,
    x2: -1566.36,
    y2: 2707.8809,
    gradientTransform: "matrix(0.1498 0.9887 -0.9887 0.1498 4316.0396 2356.4021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000148628956092909201080000015270708147394804917_)"
    },
    d: "M1368.937,1196.545 c-0.652-4.305-0.034-8.841,2.049-13.03c5.288-10.612,10.9-21.313,16.681-31.805c5.836-10.596,19.155-14.453,29.747-8.617 c10.592,5.84,14.46,19.145,8.617,29.747c-5.49,9.968-10.82,20.133-15.842,30.207c-5.386,10.822-18.535,15.229-29.363,9.835 C1374.19,1209.574,1369.969,1203.353,1368.937,1196.545z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065058635819204198940000005766199274126985605_",
    gradientUnits: "userSpaceOnUse",
    x1: 3181.1462,
    y1: 1949.1099,
    x2: 2483.5684,
    y2: 3267.969,
    gradientTransform: "matrix(-0.0605 -0.9982 -0.9982 0.0605 4704.6011 4383.2476)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065058635819204198940000005766199274126985605_)"
    },
    d: "M1624.509,1187.713 c-2.931,3.236-3.487,7.977-1.383,11.802l60.025,109.16c-28.192,50.889-48.475,106.64-59.234,165.536l-115.545,46.347 c-4.054,1.625-6.628,5.644-6.413,10.005l7.379,149.245c0.217,4.362,3.177,8.106,7.367,9.324l119.555,34.722 c16.519,57.548,42.199,111.025,75.277,158.885l-48.964,114.551c-1.716,4.015-0.696,8.676,2.54,11.608l110.75,100.314 c3.239,2.933,7.979,3.488,11.803,1.383l109.16-60.024c50.889,28.194,106.642,48.474,165.537,59.233l46.349,115.548 c1.625,4.053,5.642,6.627,10.004,6.412l149.247-7.38c4.361-0.215,8.106-3.175,9.322-7.369l34.723-119.555 c57.548-16.517,111.026-42.197,158.884-75.275l114.552,48.964c4.013,1.714,8.676,0.695,11.607-2.541l100.313-110.751 c2.934-3.236,3.487-7.977,1.384-11.802l-60.026-109.16c28.195-50.888,48.476-106.641,59.234-165.536l115.549-46.348 c4.052-1.626,6.627-5.642,6.413-10.004l-7.381-149.246c-0.214-4.362-3.173-8.105-7.368-9.323l-119.555-34.722 c-16.515-57.548-42.198-111.026-75.276-158.885l48.963-114.549c1.719-4.015,0.697-8.679-2.539-11.61l-110.751-100.313 c-3.236-2.931-7.976-3.486-11.802-1.384l-109.16,60.024c-50.889-28.194-106.642-48.474-165.537-59.233l-46.348-115.548 c-1.624-4.051-5.643-6.628-10.005-6.41l-149.243,7.379c-4.362,0.216-8.106,3.174-9.325,7.367l-34.722,119.555 c-57.546,16.518-111.024,42.199-158.884,75.275l-114.551-48.962c-4.016-1.717-8.676-0.697-11.609,2.539L1624.509,1187.713z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2012.404,1595.188c-10.968-72.391,32.56-144.01,104.617-166.041 c79.209-24.213,163.337,20.525,187.553,99.727c11.74,38.371,7.818,79.011-11.017,114.427 c-18.833,35.424-50.337,61.395-88.706,73.121c-79.21,24.214-163.337-20.525-187.553-99.726 C2015.117,1609.556,2013.491,1602.365,2012.404,1595.188z M2274.855,1555.773c-0.847-5.591-2.104-11.149-3.787-16.656 c-18.562-60.725-83.077-95.024-143.797-76.464c-60.727,18.566-95.056,83.064-76.466,143.801 c18.561,60.725,83.076,95.024,143.796,76.464c29.422-8.995,53.573-28.903,68.017-56.065 C2274.353,1604.777,2278.533,1580.051,2274.855,1555.773z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1798.371,1630.721c-1.884-12.433-3.153-25.033-3.784-37.764l0,0 c-0.2-4.006-0.332-8.018-0.403-12.031c-0.341-19.784,0.893-39.563,3.68-59.033c0.038-0.265,0.075-0.531,0.112-0.796 c0.111-0.752,0.222-1.504,0.342-2.258c0.219-1.465,0.457-2.928,0.693-4.388c0.629-3.841,3.668-6.686,7.321-7.244 c0.888-0.134,1.814-0.132,2.746,0.021c4.774,0.783,7.992,5.296,7.218,10.063c-4.039,24.565-5.453,49.728-4.208,74.794 c6.136,124.513,76.654,230.87,177.678,288.454c56.187,32.036,121.817,48.975,191.068,45.547 c12.144-0.598,24.169-1.805,36.027-3.606c79.807-12.1,152.421-50.956,207.338-111.591 c63.086-69.646,95.274-159.694,90.633-253.545c-9.604-193.831-175.008-343.582-368.747-334.001 c-11.946,0.59-23.818,1.783-35.565,3.567c-50.907,7.722-99.56,26.496-142.399,55.148c-1.108,0.739-2.319,1.195-3.555,1.378 c-3.248,0.492-6.647-0.875-8.594-3.79c-2.679-4.032-1.624-9.462,2.415-12.154c44.976-30.08,96.056-49.797,149.5-57.903 c12.331-1.873,24.79-3.124,37.328-3.748c203.409-10.06,377.06,147.297,387.118,350.633 c4.874,98.531-28.92,193.057-95.148,266.173c-57.651,63.658-133.883,104.447-217.665,117.153 c-12.45,1.886-25.072,3.153-37.815,3.787c-98.536,4.87-193.066-28.918-266.181-95.143 C1851.856,1790.78,1811.067,1714.523,1798.371,1630.721z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095326858834313171090000012962681405927317416_",
    gradientUnits: "userSpaceOnUse",
    x1: -1335.1666,
    y1: 1922.1179,
    x2: -1300.2424,
    y2: 1922.1179,
    gradientTransform: "matrix(0.4626 0.8866 -0.8866 0.4626 3165.1211 1020.4797)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000095326858834313171090000012962681405927317416_)"
    },
    d: "M827.348,758.645 c-2.655-5.089-1.781-11.508,2.568-15.691c8.113-7.813,16.574-15.487,25.149-22.804c5.572-4.755,13.939-4.094,18.704,1.479 c4.787,5.563,4.092,13.948-1.479,18.705c-8.17,6.973-16.235,14.287-23.98,21.741c-5.27,5.08-13.67,4.918-18.76-0.355 C828.651,760.778,827.921,759.742,827.348,758.645z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182510536247059062980000001871891175121950091_",
    gradientUnits: "userSpaceOnUse",
    x1: 2026.4469,
    y1: 1418.1949,
    x2: 2745.6746,
    y2: 1418.1949,
    gradientTransform: "matrix(-0.5178 -0.8555 -0.8555 0.5178 3795.6523 2140.9966)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182510536247059062980000001871891175121950091_)"
    },
    d: "M907.059,694.905 c-3.11-5.961-1.263-13.429,4.469-17.201c16.194-10.672,33.124-20.631,50.307-29.597c3.618-1.888,7.27-3.741,10.95-5.567 c6.576-3.249,14.466-0.088,17.788,5.998c3.251,6.567,0.563,14.525-5.995,17.779c-3.519,1.742-7.011,3.511-10.468,5.315 c-16.392,8.553-32.538,18.052-47.984,28.223c-6.122,4.035-14.344,2.341-18.381-3.773 C907.499,695.692,907.265,695.302,907.059,694.905z M1030.514,633.777c-0.29-0.556-0.553-1.143-0.767-1.747 c-2.426-6.918,1.208-14.492,8.122-16.924c22.178-7.801,45.039-14.292,67.933-19.29c7.162-1.567,14.227,3.012,15.793,10.131 c1.561,7.165-2.968,14.225-10.13,15.792c-21.844,4.77-43.647,10.965-64.801,18.401 C1040.365,642.352,1033.517,639.532,1030.514,633.777z M1165.105,604.413c-0.779-1.493-1.282-3.159-1.45-4.936 c-0.664-7.296,4.724-13.747,12.02-14.411c23.377-2.114,47.149-2.797,70.638-2.002c7.333,0.244,13.054,6.364,12.81,13.71 c-0.245,7.318-6.385,13.057-13.702,12.812c-22.403-0.754-45.058-0.114-67.354,1.911 C1172.552,611.992,1167.518,609.036,1165.105,604.413z M1302.803,609.035c-1.271-2.436-1.793-5.283-1.341-8.2 c1.15-7.235,7.951-12.18,15.187-11.031c23.23,3.685,46.424,8.842,68.958,15.337c7.039,2.035,11.087,9.4,9.067,16.424 c-2.025,7.041-9.376,11.102-16.426,9.075c-21.472-6.195-43.608-11.115-65.754-14.627 C1308.176,615.329,1304.682,612.636,1302.803,609.035z M1435.19,647.147c-1.774-3.401-2.066-7.545-0.443-11.352 c2.871-6.736,10.664-9.867,17.407-6.999c21.602,9.219,42.845,19.85,63.129,31.613c6.357,3.669,8.505,11.792,4.828,18.131 c-3.678,6.34-11.8,8.502-18.13,4.827c-19.359-11.221-39.618-21.367-60.236-30.155 C1438.811,651.958,1436.56,649.771,1435.19,647.147z M1554.301,716.227c-2.299-4.405-2.011-9.934,1.19-14.161 c4.422-5.836,12.742-6.976,18.584-2.557c18.715,14.188,36.722,29.681,53.504,46.046c5.244,5.148,5.344,13.521,0.234,18.767 c-5.111,5.245-13.517,5.35-18.758,0.237c-16.007-15.609-33.166-30.374-51.008-43.899 C1556.429,719.435,1555.179,717.91,1554.301,716.227z M1652.881,812.307c-2.877-5.513-1.552-12.467,3.482-16.489 c5.725-4.573,14.074-3.64,18.652,2.082c14.614,18.287,28.266,37.732,40.592,57.797c3.737,6.321,1.871,14.427-4.374,18.254 c-6.242,3.835-14.41,1.879-18.249-4.361c-11.745-19.148-24.769-37.693-38.703-55.128 C1653.735,813.776,1653.271,813.053,1652.881,812.307z M1749.664,994.154c-0.353-0.677-0.659-1.403-0.895-2.164 c-5.812-18.45-12.737-36.904-20.585-54.856c-1.174-2.726-2.358-5.389-3.574-8.029c-3.042-6.671-0.118-14.538,6.548-17.586 c6.674-3.065,14.755-0.179,17.589,6.54c1.283,2.823,2.551,5.647,3.781,8.506c8.193,18.758,15.453,38.104,21.545,57.453 c2.201,6.992-1.675,14.437-8.666,16.638C1759.181,1002.619,1752.586,999.754,1749.664,994.154z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086660377857088440940000011602405024265344701_",
    gradientUnits: "userSpaceOnUse",
    x1: 1675.8162,
    y1: 2108.1169,
    x2: 2471.2297,
    y2: 2108.1169,
    gradientTransform: "matrix(-0.5178 -0.8555 -0.8555 0.5178 3795.6523 2140.9966)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000086660377857088440940000011602405024265344701_)"
    },
    d: "M723.013,1427.88 c-3.351-6.421-0.92-14.368,5.479-17.816c6.446-3.473,14.499-1.062,17.969,5.392c10.457,19.425,22.187,38.375,34.869,56.325 c4.146,5.985,2.812,14.266-3.181,18.495c-5.991,4.23-14.266,2.797-18.495-3.181c-13.289-18.831-25.596-38.693-36.557-59.054 C723.07,1427.989,723.039,1427.932,723.013,1427.88z M694.485,1366.289c-0.222-0.426-0.417-0.857-0.596-1.311 c-8.442-21.5-15.658-43.733-21.457-66.078c-1.832-7.097,2.415-14.332,9.509-16.17c7.102-1.85,14.333,2.458,16.182,9.503 c5.529,21.324,12.418,42.537,20.466,63.057c2.68,6.816-0.683,14.518-7.5,17.192 C704.708,1374.985,697.578,1372.216,694.485,1366.289z M801.198,1538.512c-2.721-5.216-1.716-11.804,2.842-15.951 c5.411-4.922,13.802-4.527,18.734,0.894c14.86,16.324,30.825,31.881,47.48,46.237c5.539,4.818,6.167,13.164,1.374,18.712 c-4.778,5.547-13.164,6.168-18.714,1.384c-17.455-15.051-34.195-31.365-49.761-48.481 C802.363,1540.439,801.713,1539.5,801.198,1538.512z M660.534,1235.061c-0.698-1.337-1.179-2.818-1.392-4.402 c-3.026-22.914-4.664-46.248-4.863-69.344c-0.068-7.329,5.823-13.319,13.153-13.388c7.307-0.056,13.302,5.832,13.379,13.15 c0.196,22.024,1.76,44.263,4.64,66.113c0.955,7.262-4.157,13.933-11.42,14.888 C668.354,1242.825,663.039,1239.863,660.534,1235.061z M903.801,1626.954c-2.173-4.164-2.064-9.359,0.731-13.527 c4.081-6.098,12.322-7.724,18.409-3.651c18.29,12.255,37.522,23.512,57.18,33.459c6.551,3.312,9.155,11.299,5.842,17.836 c-3.312,6.536-11.299,9.155-17.835,5.843c-20.603-10.44-40.774-22.239-59.955-35.081 C906.261,1630.552,904.793,1628.855,903.801,1626.954z M1024.628,1688.204c-1.663-3.188-2.031-7.03-0.714-10.669 c2.5-6.888,10.111-10.449,16.998-7.949c20.75,7.528,42.134,13.864,63.549,18.832c7.148,1.656,11.589,8.794,9.93,15.922 c-1.653,7.139-8.777,11.579-15.911,9.924c-22.459-5.205-44.877-11.842-66.619-19.731 C1028.619,1693.356,1026.109,1691.042,1024.628,1688.204z M1156.663,1718.747c-1.168-2.24-1.718-4.832-1.42-7.538 c0.773-7.287,7.314-12.564,14.603-11.786c21.938,2.357,44.216,3.374,66.206,3.03c7.312-0.104,13.356,5.738,13.464,13.062 c0.112,7.328-5.73,13.358-13.064,13.473c-23.054,0.352-46.421-0.71-69.436-3.17 C1162.432,1725.324,1158.646,1722.549,1156.663,1718.747z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181802353505442457890000003433470954913259665_",
    gradientUnits: "userSpaceOnUse",
    x1: -1129.7095,
    y1: 2234.8079,
    x2: -1076.2808,
    y2: 2234.8079,
    gradientTransform: "matrix(0.4626 0.8866 -0.8866 0.4626 3165.1211 1020.4797)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181802353505442457890000003433470954913259665_)"
    },
    d: "M659.364,1098.911 c-1.184-2.269-1.724-4.902-1.412-7.637c1.289-11.283,2.922-22.576,4.841-33.574c1.264-7.214,8.137-12.05,15.357-10.79 c7.2,1.279,12.035,8.138,10.789,15.357c-1.836,10.486-3.389,21.263-4.625,32.029c-0.833,7.281-7.416,12.506-14.691,11.67 C665.081,1105.442,661.333,1102.685,659.364,1098.911z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069375436610108739140000013559901468087967886_",
    gradientUnits: "userSpaceOnUse",
    x1: 2572.344,
    y1: 1573.3802,
    x2: 2764.7947,
    y2: 2738.771,
    gradientTransform: "matrix(-0.3812 -0.9245 -0.9245 0.3812 4190.9697 2811.2061)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000069375436610108739140000013559901468087967886_)"
    },
    d: "M816.422,1029.402 c-1.13,2.632-0.466,5.695,1.656,7.621l60.522,54.984c-6.662,37.599-7.377,76.533-1.51,115.39l-61.861,53.39 c-2.171,1.872-2.913,4.915-1.85,7.577l36.376,91.085c1.064,2.662,3.699,4.355,6.561,4.219l81.621-3.914 c22.515,32.209,49.851,59.939,80.583,82.605l-5.995,81.548c-0.209,2.858,1.417,5.535,4.051,6.666l90.128,38.684 c2.635,1.13,5.696,0.465,7.623-1.656l54.983-60.521c37.6,6.663,76.534,7.377,115.391,1.509l53.39,61.863 c1.873,2.17,4.915,2.912,7.577,1.85l91.086-36.377c2.663-1.063,4.357-3.698,4.218-6.56l-3.913-81.622 c32.21-22.514,59.939-49.851,82.604-80.582l81.551,5.994c2.857,0.209,5.534-1.417,6.664-4.049l38.685-90.13 c1.131-2.633,0.465-5.694-1.656-7.621l-60.523-54.983c6.665-37.599,7.377-76.533,1.509-115.39l61.863-53.391 c2.169-1.872,2.913-4.914,1.85-7.577l-36.378-91.086c-1.063-2.662-3.697-4.355-6.56-4.218l-81.621,3.914 c-22.514-32.21-49.852-59.94-80.584-82.606l5.995-81.546c0.211-2.859-1.417-5.537-4.05-6.667l-90.128-38.684 c-2.634-1.13-5.695-0.466-7.623,1.656l-54.983,60.52c-37.6-6.663-76.534-7.375-115.391-1.508l-53.39-61.864 c-1.871-2.168-4.915-2.913-7.577-1.847l-91.084,36.375c-2.662,1.064-4.356,3.698-4.219,6.561l3.913,81.622 c-32.208,22.515-59.938,49.851-82.605,80.581l-81.549-5.993c-2.859-0.21-5.534,1.417-6.667,4.05L816.422,1029.402z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1142.407,1200.434c-9.901-18.975-13.45-40.536-10.02-62.055 c4.223-26.471,18.504-49.713,40.211-65.445c44.787-32.474,107.656-22.45,140.149,22.348 c32.442,44.922,22.445,107.689-22.356,140.162c-21.705,15.738-48.239,22.078-74.703,17.852 c-26.476-4.218-49.723-18.497-65.453-40.212C1147.299,1209.026,1144.682,1204.794,1142.407,1200.434z M1296.967,1120.074 c-1.651-3.165-3.551-6.243-5.703-9.221c-23.9-32.95-70.143-40.323-103.1-16.433c-15.957,11.57-26.473,28.669-29.571,48.136 c-3.105,19.48,1.575,38.981,13.128,54.962l0,0c11.573,15.963,28.675,26.47,48.14,29.576 c19.48,3.105,38.995-1.559,54.965-13.137C1304.802,1192.228,1313.615,1151.979,1296.967,1120.074z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1011.969,1270.643c-3.884-7.443-7.418-15.143-10.604-23.097 c-6.315-15.799-11.029-32.257-14.015-48.959c-0.129-0.751-0.257-1.503-0.386-2.254c-0.988-5.813,1.968-11.381,6.927-13.976 c1.206-0.629,2.534-1.081,3.943-1.32c7.223-1.225,14.042,3.664,15.288,10.869c2.64,15.62,6.981,31.023,12.885,45.786 l0.003,0.006c0.321,0.811,0.658,1.622,0.987,2.422c14.292,34.814,36.721,64.747,65.161,87.884 c15.438,12.557,32.665,23.109,51.349,31.329c0.152,0.067,0.303,0.134,0.455,0.201c0.471,0.2,0.929,0.407,1.396,0.602 c54.836,23.531,115.554,24.309,170.968,2.176c7.174-2.859,14.141-6.063,20.895-9.587 c45.44-23.717,81.044-62.024,101.541-109.765c23.532-54.836,24.297-115.549,2.167-170.958 c-22.138-55.368-64.52-98.894-119.348-122.438c-54.834-23.531-115.554-24.309-170.968-2.176 c-7.053,2.811-13.936,5.979-20.621,9.467c-28.991,15.134-54.339,36.434-74.161,62.472c-1.224,1.604-2.735,2.853-4.415,3.722 c-4.411,2.302-9.954,2.015-14.176-1.204c-5.817-4.455-6.964-12.758-2.515-18.601c22.182-29.133,50.547-52.972,82.968-69.903 c7.489-3.908,15.185-7.449,23.071-10.598c62.007-24.762,129.934-23.895,191.287,2.44 c61.34,26.334,108.791,74.925,133.521,136.971c24.765,61.998,23.904,129.922-2.439,191.274 c-22.917,53.411-62.755,96.265-113.593,122.799c-7.547,3.938-15.349,7.527-23.366,10.73 C1206.136,1434.887,1070.521,1382.859,1011.969,1270.643z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170972819911220111080000008978220144584386716_",
    gradientUnits: "userSpaceOnUse",
    x1: -3139.4133,
    y1: 3217.4456,
    x2: -3045.0098,
    y2: 3217.4456,
    gradientTransform: "matrix(-1 0 0 1 37.6671 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170972819911220111080000008978220144584386716_)"
    },
    d: "M3163.938,3184.18 c0,0,10.49,16.535,13.129,62.831c0.246,4.314-3.171,7.989-7.491,7.989h-82.044c-3.301,0-5.657-3.237-4.6-6.364 c4.808-14.229,19.344-48.921,51.779-68.745L3163.938,3184.18z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005967202148016777820000013370784478236079234_",
    gradientUnits: "userSpaceOnUse",
    x1: -3129.8367,
    y1: 3173.5774,
    x2: -3091.5503,
    y2: 3173.5774,
    gradientTransform: "matrix(-1 0 0 1 37.6671 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005967202148016777820000013370784478236079234_)"
    },
    d: "M3167.504,3152.81l-4.64,38.91 c-0.4,3.357-3.031,6.044-6.39,6.431c-4.487,0.517-11.01,0.881-17.348-0.165c-5.762-0.95-9.908-6.082-9.908-11.922v-37.567 L3167.504,3152.81z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000941737330285201950000006825569250822599084_",
    gradientUnits: "userSpaceOnUse",
    x1: -2938.6528,
    y1: 3215.936,
    x2: -2790.5305,
    y2: 3215.936,
    gradientTransform: "matrix(-1 0 0 1 37.6671 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000941737330285201950000006825569250822599084_)"
    },
    d: "M2960.948,3179.891 c0,0,15.703,24.409,15.367,57.913c-0.079,7.891-6.686,14.177-14.578,14.177h-127.423c-5.967,0-8.389-7.667-3.506-11.096 c24.112-16.932,71.504-48.563,105.781-60.995H2960.948z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016764600604274148640000007009737520979982252_",
    gradientUnits: "userSpaceOnUse",
    x1: -2936.4031,
    y1: 3156.5762,
    x2: -2898.3269,
    y2: 3156.5762,
    gradientTransform: "matrix(-1 0 0 1 37.6671 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016764600604274148640000007009737520979982252_)"
    },
    d: "M2974.07,3137.87l-9.898,48.055 c-1.107,5.375-6.365,8.989-11.721,7.794c-3.256-0.727-7.097-2.119-11.202-4.685c-3.901-2.439-5.878-7.079-5.081-11.61 l10.239-58.218L2974.07,3137.87z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000133490695838871008740000006033628024531463352_",
    gradientUnits: "userSpaceOnUse",
    x1: -3153.6262,
    y1: 2818.833,
    x2: -2894.0498,
    y2: 2818.833,
    gradientTransform: "matrix(-1 0 0 1 37.6671 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000133490695838871008740000006033628024531463352_)"
    },
    d: "M3149.323,2469.739 c0,0,34.416,30.341,40.892,66.845c6.477,36.504-18.35,629.82-18.35,629.82s-34.414,5.726-52.154-5.024 c0,0-21.041-385.058-37.034-474.035c0,0-83.875,398.869-107.114,470.94c0,0-33.155,4.033-43.846-2.275 c0,0,21.971-517.046,49.578-608.969L3149.323,2469.739z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179634774915124502190000004637892216859467648_",
    gradientUnits: "userSpaceOnUse",
    x1: 3080.0234,
    y1: 2632.9229,
    x2: 3133.5315,
    y2: 2632.9229
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000179634774915124502190000004637892216859467648_)"
    },
    d: "M3083.678,2674.747 c1.622,0,3.103-1.089,3.531-2.73l14.26-54.701l30.38-19.489c1.698-1.089,2.192-3.348,1.103-5.046 c-1.089-1.698-3.352-2.197-5.046-1.099l-31.583,20.26c-0.773,0.495-1.332,1.26-1.562,2.15l-14.62,56.08 c-0.509,1.955,0.661,3.948,2.613,4.457C3083.063,2674.709,3083.374,2674.747,3083.678,2674.747z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143601915217555366960000000712353659262028947_",
    gradientUnits: "userSpaceOnUse",
    x1: 2823.9094,
    y1: 2179.0562,
    x2: 2773.3889,
    y2: 3593.6392
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000143601915217555366960000000712353659262028947_)"
    },
    d: "M2813.3,2060.206 c140.52,37.257,166.136,78.201,166.136,78.201l-102.452,80.198c0,0-133.167-50.391-202.896-158.666 c24.88-12.966,44.99-29.924,58.934-43.739C2754.136,2035.318,2780.522,2051.515,2813.3,2060.206z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000912837646898769230000005996648490993472396_",
    gradientUnits: "userSpaceOnUse",
    x1: -1462.4333,
    y1: 1208.3876,
    x2: -1320.9268,
    y2: 1208.3876,
    gradientTransform: "matrix(-0.9421 -0.3354 -0.3354 0.9421 1784.2705 320.6685)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000912837646898769230000005996648490993472396_)"
    },
    d: "M2670.885,1783.776 c1.741-4.308,8.092-3.388,8.539,1.237l4.187,43.363c0.808,8.379-0.975,16.803-5.111,24.135l-13.809,19.456 c-5.583,9.898-6.675,21.687-2.964,32.428c8.88,25.702,29.954,74.372,71.295,111.804c-13.944,13.815-34.054,30.773-58.934,43.739 c-25.585-39.727-42.641-87.239-41.428-142.926c-7.049-5.249-9.685-14.582-6.425-22.743L2670.885,1783.776z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049938705928773383080000017234645959930277307_",
    gradientUnits: "userSpaceOnUse",
    x1: 2601.6296,
    y1: 2858.7681,
    x2: 3241.4954,
    y2: 1875.3939
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049938705928773383080000017234645959930277307_)"
    },
    d: "M2762.016,2190.634 c51.002-54.957,148.149-79.786,204.394-89.985c24.641-4.469,48.931,9.243,57.662,32.715 c25.312,68.041,94.152,245.059,107.494,275.483c10.947,24.959,22.377,49.336,29.64,64.577c4.339,9.105,0.548,20-8.539,24.379 c-47.321,22.81-132.471,48.616-166.992,58.683c-7.593,2.215-15.154-3.487-15.154-11.396c0-6.708-1.823-13.291-5.275-19.042 l-130.739-217.866c-81.488,90.353-152.851,98.615-207.671,78.839c9.218-28.488,15.25-57.028,18.143-85.623 C2725.968,2287.524,2762.016,2190.634,2762.016,2190.634z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123421232560107414540000003659348193597351328_",
    gradientUnits: "userSpaceOnUse",
    x1: -2361.228,
    y1: 2072.5198,
    x2: -2666.9893,
    y2: 2452.916,
    gradientTransform: "matrix(-1 0 0 1 37.6671 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000123421232560107414540000003659348193597351328_)"
    },
    d: "M2511.119,2286.235l14.616-19.488 c47.317,32.496,86.868,40.198,119.246,34.651c-2.893,28.594-8.925,57.135-18.143,85.623 C2554.618,2360.968,2511.119,2286.235,2511.119,2286.235z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062879725668954468670000001893260651776978611_",
    gradientUnits: "userSpaceOnUse",
    x1: -2303.2576,
    y1: 2119.1165,
    x2: -2609.0183,
    y2: 2499.5122,
    gradientTransform: "matrix(-1 0 0 1 37.6671 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062879725668954468670000001893260651776978611_)"
    },
    d: "M2521.425,2286.587l-82.341,3.21 l-75.812-42.342c10.882-6.822,72.421,7.121,72.421,7.121s64.331-9.729,81.742-9.752c14.461-0.019,12.395,20.776,11.28,27.823 c-0.228,1.438-0.416,2.303-0.416,2.303L2521.425,2286.587z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060743157863004651380000000393621164660643984_",
    gradientUnits: "userSpaceOnUse",
    x1: -2705.2107,
    y1: 1842.6283,
    x2: -3001.3418,
    y2: 2386.7397,
    gradientTransform: "matrix(-1 0 0 1 37.6671 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060743157863004651380000000393621164660643984_)"
    },
    d: "M2889.047,1999.718l43.445,106.015 c0,0-49.918,34.552-90.079,31.263l-21.682-95.327L2889.047,1999.718z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155116758993376804990000005703188694051561897_",
    gradientUnits: "userSpaceOnUse",
    x1: -2577.3494,
    y1: 2307.2363,
    x2: -2708.2224,
    y2: 2480.3708,
    gradientTransform: "matrix(-0.817 -0.5767 -0.5767 0.817 2061.095 -1428.4956)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155116758993376804990000005703188694051561897_)"
    },
    d: "M2815.659,1927.445 c-0.995,1.409-31.43,111.358-31.43,111.358l63.149,16.043l44.328-99.923C2891.706,1954.923,2832.317,1903.844,2815.659,1927.445 z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091707181426836453770000009593608530530799769_",
    gradientUnits: "userSpaceOnUse",
    x1: -2677.2988,
    y1: 2349.0005,
    x2: -2520.9688,
    y2: 2349.0005,
    gradientTransform: "matrix(-0.817 -0.5767 -0.5767 0.817 2061.095 -1428.4956)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091707181426836453770000009593608530530799769_)"
    },
    d: "M2867.926,1970.105l-19.216,54.428 c-0.246,0.698-0.577,1.344-1.003,1.949c-2.608,3.705-12.514,15.794-24.264,4.905c-10.662-9.881-20.54-18.74-29.662-20.348 c-4.096-0.722-8.064,1.777-9.172,5.786c-2.762,9.99-8.572,32.617-10.619,53.046c-0.415,4.146,2.447,7.892,6.54,8.669 c12.334,2.343,38.484,6.554,60.316,5.015c2.958-0.208,5.561-1.983,6.795-4.68c6.016-13.146,24.45-53.035,31.306-63.356 c6.435-9.687,22.21-9.416,28.826-8.829c2.169,0.192,4.302-0.506,5.939-1.942c5.788-5.073,16.803-18.026,1.308-33.532 c-3.243-3.245-3.156-8.48,0.187-11.624c6.654-6.256,13.771-17.353,2.685-31.115c-11.269-13.989-26.144-11.762-35.258-8.437 c-3.685,1.345-7.705-0.213-9.708-3.586c-1.14-1.92-3.13-3.373-6.579-3.076c-4.648,0.4-8.556-3.479-8.473-8.144 c0.161-8.962-3.047-20.284-18.593-25.122c-27.585-8.586-44.788,18.064-46.492,37.951c-1.704,19.886,28.734,27.494,46.631,26.153 c13.608-1.02,23.712,12.468,27.773,18.992C2868.479,1965.275,2868.737,1967.809,2867.926,1970.105z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000020388276939984129900000016632821317762951297_",
    gradientUnits: "userSpaceOnUse",
    x1: -2769.0273,
    y1: 2444.345,
    x2: -2664.0562,
    y2: 2336.6472,
    gradientTransform: "matrix(-0.817 -0.5767 -0.5767 0.817 2061.095 -1428.4956)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000020388276939984129900000016632821317762951297_)"
    },
    d: "M2871.754,2035.267 c0,0,4.455-34.523,18.817-36.215c14.362-1.691,28.34,10.111,14.062,29.489 C2886.872,2052.645,2871.754,2035.267,2871.754,2035.267z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1501.35,3249.182H464.927v-539.355c0-26.874,21.785-48.659,48.659-48.659h939.104 c26.874,0,48.659,21.785,48.659,48.659V3249.182z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155130620826826634940000010264508625452115369_",
    gradientUnits: "userSpaceOnUse",
    x1: -970.3849,
    y1: 1262.6564,
    x2: -883.1902,
    y2: 1481.3826,
    gradientTransform: "matrix(-1 0 0 1 32.9772 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155130620826826634940000010264508625452115369_)"
    },
    d: "M951.661,1380.313 c0,0-29.396,14.298-34.8,30.723c-4.337,13.179-36.84,14.878-40.051,40.797c-1.658,13.383-11.561,24.099-24.89,26.142 c-33.197,5.089-84.356,22.327-92.542,79.965c-6.248,43.994,16.179,60.676,39.716,66.45c17.288,4.241,28.776,21.055,25.279,38.508 c-3.353,16.74,1.648,36.093,30.649,51.396c64.99,34.292,129.892-81.242,129.892-81.242l13.301-201.73L951.661,1380.313z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182486348586416257470000000641188602632630181_",
    gradientUnits: "userSpaceOnUse",
    x1: -651.6381,
    y1: 2662.9641,
    x2: -577.7004,
    y2: 2662.9641,
    gradientTransform: "matrix(-1 0 0 1 32.9772 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182486348586416257470000000641188602632630181_)"
    },
    d: "M684.527,2645.232l-4.205,34.573 c-0.798,6.558-5.962,11.745-12.526,12.495c-11.083,1.266-28.868,2.564-46.27,0.724c-7.638-0.807-12.597-8.542-10.27-15.862 c4.243-13.346,12.003-33.381,23.192-45.172h38.352C679.89,2631.99,685.383,2638.192,684.527,2645.232z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171693987977921812650000002388723783246962055_",
    gradientUnits: "userSpaceOnUse",
    x1: -964.0637,
    y1: 2954.5344,
    x2: -857.6617,
    y2: 1710.9619,
    gradientTransform: "matrix(-1 0 0 1 32.9772 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000171693987977921812650000002388723783246962055_)"
    },
    d: "M984.913,2240.234l6.474,38.079 c0,0-21.677,219.575-25.534,307.405c-0.605,13.77,2.958,27.378,10.185,39.114l37.693,61.211l-95.797-56.529l-1.908-11.69 l15.683-21.562l-20.541-245.979c-1.207-14.45,1.775-28.942,8.589-41.742l19.815-37.225L984.913,2240.234z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034073131135265104580000015461790488400527020_",
    gradientUnits: "userSpaceOnUse",
    x1: -995.1468,
    y1: 2649.4651,
    x2: -875.5098,
    y2: 2649.4651,
    gradientTransform: "matrix(-1 0 0 1 32.9772 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034073131135265104580000015461790488400527020_)"
    },
    d: "M1020.04,2694.91h-30.571 c-5.721,0-11.118-2.627-14.608-7.162c-9.53-12.383-29.276-36.544-38.718-37.175c-12.71-0.849-11.084,44.337-11.084,44.337h-7.124 l-9.025-56.148c-2.271-14.127,4.755-28.122,17.441-34.742l0,0c0,0,2.905,21.487,18.66,30.991 c15.754,9.505,64.109,43.541,64.109,43.541s5.922-0.844,12.424,0.331C1031.189,2680.625,1029.843,2694.91,1020.04,2694.91z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158742558224307698330000001222631096760450178_",
    gradientUnits: "userSpaceOnUse",
    x1: -750.0297,
    y1: 2973.0386,
    x2: -643.5997,
    y2: 1729.1378,
    gradientTransform: "matrix(-1 0 0 1 32.9772 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158742558224307698330000001222631096760450178_)"
    },
    d: "M853.702,2258.319 c0,0-126.993,240.894-147.181,295.895c-20.187,55-27.259,100.882-27.53,105.227c-0.423,6.789-8.867,13.301-32.144,13.301 c-12.012,0-17.895-4.816-20.776-9.476c-2.458-3.976-2.584-8.952-0.513-13.143c7.345-14.866,30.658-62.377,39.292-83.925 c10.308-25.728,32.482-142.323,44.642-182.861c12.161-40.539,25.907-84.512,78.864-125.018 C788.356,2258.319,824.71,2222.713,853.702,2258.319z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155842787119238170380000007585219867125134982_",
    gradientUnits: "userSpaceOnUse",
    x1: 1046.1002,
    y1: 1547.6742,
    x2: 530.7863,
    y2: 2911.7368
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155842787119238170380000007585219867125134982_)"
    },
    d: "M933.926,1863.602 c32.758-138.811-50.229-217.321-50.229-217.321c52.363-50.263,147.769-73.134,147.769-73.134s91.037,66.557,80.238,118.652 c-6.33,30.533-63.991,182.888-63.991,182.888S994.395,1899.919,933.926,1863.602z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101813055613581907130000000193809936485766543_",
    gradientUnits: "userSpaceOnUse",
    x1: 1276.3054,
    y1: 1178.8763,
    x2: 760.9911,
    y2: 2542.9399
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101813055613581907130000000193809936485766543_)"
    },
    d: "M861.296,1932.323 c13.331-40.162,72.631-68.721,72.631-68.721c60.469,36.317,113.787,11.084,113.787,11.084s11.957,45.705,3.704,88.18 s-60.031,315.447-60.031,315.447c-81.586,16.531-207.062-16.632-207.062-16.632 C836.291,2169.417,847.964,1972.486,861.296,1932.323z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108991723128011847950000000895419939591753902_",
    gradientUnits: "userSpaceOnUse",
    x1: -975.7324,
    y1: 1728.7443,
    x2: -955.7451,
    y2: 1582.5225,
    gradientTransform: "matrix(-1 0 0 1 32.9772 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000108991723128011847950000000895419939591753902_)"
    },
    d: "M971.951,1481.415l-26.634,119.632 c-2.549,10.537,7.056,8.813,17.709,6.804c17.447-3.289,39.934-10.064,47.451-23.64c0.765-1.381,1.148-2.943,1.363-4.508 l11.442-82.955c0.908-6.582-2.65-12.969-8.724-15.662l-22.08-9.79C983.978,1467.526,974.138,1472.376,971.951,1481.415z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042007025657846945190000011477201571578506151_",
    gradientUnits: "userSpaceOnUse",
    x1: -1026.1809,
    y1: 1540.2197,
    x2: -851.791,
    y2: 1229.8643,
    gradientTransform: "matrix(-1 0 0 1 32.9772 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000042007025657846945190000011477201571578506151_)"
    },
    d: "M1003.2,1367.509 c0,0,31.543,13.319,52.99,58.9c21.448,45.58,5.431,66.626-14.687,69.515c-20.118,2.889-50.205,2.449-82.029-26.995 C927.651,1439.484,962.195,1351.721,1003.2,1367.509z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028284925713041826770000001577032879575936387_",
    gradientUnits: "userSpaceOnUse",
    x1: -988.6785,
    y1: 1269.9485,
    x2: -901.4837,
    y2: 1488.6748,
    gradientTransform: "matrix(-1 0 0 1 32.9772 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000028284925713041826770000001577032879575936387_)"
    },
    d: "M980.867,1444.594 c0,0-23.798-66.686,35.325-67.474l13.913,9.724c0,0,21.693-36.973-13.913-54.622c-35.605-17.649-77.276-3.071-92.429,44.898 c-15.152,47.969-17.739,80.08,7.469,103.031c25.208,22.95,35.597-3.073,35.597-3.073s-13.728-21.466-8.139-32.951 c5.588-11.484,18.478,2.376,18.478,2.376L980.867,1444.594z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000113312031914514984050000015539186527643478198_",
    gradientUnits: "userSpaceOnUse",
    x1: -989.0604,
    y1: 1561.079,
    x2: -814.6697,
    y2: 1250.7223,
    gradientTransform: "matrix(-1 0 0 1 32.9772 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000113312031914514984050000015539186527643478198_)"
    },
    d: "M974.236,1452.022 c0,0-12.032-34.352-28.083-20.672c-16.052,13.68,13.046,31.732,24.436,37.578L974.236,1452.022z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124879950960439741670000001425744653052824466_",
    gradientUnits: "userSpaceOnUse",
    x1: 2182.2246,
    y1: 2316.4099,
    x2: 1748.1289,
    y2: 2438.387,
    gradientTransform: "matrix(0.9463 -0.3234 0.3234 0.9463 -1675.8459 108.6863)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124879950960439741670000001425744653052824466_)"
    },
    d: "M898.652,1710.003 c61.828,28.885,297.695,115.918,371.58-195.524c0,0,0.507-9.32-5.603-20.444c-3.085-5.617-6.375-28.151-7.904-39.716 c-0.491-3.718-4.088-6.162-7.737-5.295l0,0c-2.859,0.68-5.175,2.769-6.145,5.542l-17.768,50.813 c0.365,8.734,7.035,15.901,15.72,16.894l0,0c5.54,0.633,9.113,6.174,7.347,11.464 c-72.304,216.462-355.774,102.925-359.027,106.508c-5.358,5.901-10.508,14.583-12.818,24.582 C872.055,1683.196,881.571,1702.023,898.652,1710.003z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorks);
export default __webpack_public_path__ + "static/media/Works.112de6673be91265910f8b5e634a5d47.svg";
export { ForwardRef as ReactComponent };